// web/src/components/NetBanner.tsx — מצבי מערכת, רוחבי: ניתוק רשת (CA-19.a · CR-13 · ST-19 · LR-12 · AC-11).
// 🔑 אותה שפה בכל הכלים. ⛔ מוחק או מסתיר את מה שעל המסך — רק אומר שהשמירה תחכה לחיבור.
import { useEffect, useState } from "react";

export function NetBanner() {
  const [online, setOnline] = useState(() => (typeof navigator === "undefined" ? true : navigator.onLine));
  useEffect(() => {
    const on = () => setOnline(true), off = () => setOnline(false);
    window.addEventListener("online", on); window.addEventListener("offline", off);
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", off); };
  }, []);
  if (online) return null;
  return (
    <div className="net-banner" role="status">
      אין חיבור לאינטרנט כרגע. מה שעל המסך נשאר; פעולות חדשות יישמרו רק כשהחיבור יחזור.
    </div>
  );
}
